<template>
  <b-modal ref="PackageModal" @hidden="hiddenModal"
           :no-close-on-backdrop="true" :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title">{{title}}</h5>
      <button type="button" aria-label="Close" class="close" tabindex="-1" @click="closeModal">×</button>
    </template>
    <slot></slot>
    <div>
      <b-row class="mb-3">
        <b-col v-if="!isHiddenFields('partner')">
          <label class="important-field"
                 title="This field is required to completing operation">{{$t('labels.common.supplier')}}</label>
          <div class="d-flex">
            <multiselect v-model="packageData.partner" :max-height="200" label="name" track-by="id"
                         placeholder="" :options="partners"
                         :disabled="isNotEditablePackageField('partner')"
                         :class="{ required: !packageData.partner}"
                         select-label="" deselect-label="" selected-label=""
                         :tabindex="13"
            ></multiselect>
            <div class="reply-icon-wrapper" @click="applyToAllPackages('partner')"
                 title="Apply provider to all packages created after this."
                 v-show="operationId && !isNotEditablePackageField('partner')">
              <icon name="reply" class="reply-icon"></icon>
            </div>
          </div>
        </b-col>
        <b-col v-if="!isHiddenFields('pre_purchase_order')">
          <label>{{$t('common_content.purchase_order')}}</label>
          <div class="d-flex">
            <multiselect v-model="packageData.pre_purchase_order" :max-height="200" :options="purchase_orders"
                         placeholder="" label="order_nr" track-by="order_nr"
                         :class="{ required: !packageData.pre_purchase_order }"
                         :disabled="isNotEditablePackageField('pre_purchase_order')"
                         select-label="" deselect-label="" selected-label=""
                         :tabindex="8"
            ></multiselect>
            <div class="reply-icon-wrapper" @click="applyToAllPackages('pre_purchase_order')"
                 title="Apply purchase order to all packages created after this."
                 v-show="operationId && !isNotEditablePackageField('pre_purchase_order')">
              <icon name="reply" class="reply-icon"></icon>
            </div>
          </div>
        </b-col>
        <b-col v-if="!isHiddenFields('contract')">
          <label>{{$t('labels.common.contract_nr')}}</label>
          <div class="d-flex">
            <multiselect v-model="packageData.contract_nr" :max-height="200" :options="relatedContracts"
                         placeholder="" label="contract_nr" track-by="id"
                         :class="{ required: contractsRequired }"
                         :disabled="isNotEditablePackageField('contract')"
                         select-label="" deselect-label="" selected-label=""
                         :tabindex="8"
            ></multiselect>
            <div class="reply-icon-wrapper" @click="applyToAllPackages('contract_nr')"
                 title="Apply contract_nr to all packages created after this."
                 v-show="operationId && !isNotEditablePackageField('contract')">
              <icon name="reply" class="reply-icon"></icon>
            </div>
          </div>
        </b-col>
      </b-row>
      <purchase-order-item-search-field
          v-if="!isHiddenFields('purchase_order_item')"
          v-model="packageData.purchase_order_item"
          :purchaseOrder="packageData.pre_purchase_order"
          :contract="packageData.contract_nr"
          @input="setFieldsByPurchaseOrderItem"
      />
      <b-row v-if="packageData.type === 'single'">
        <b-col v-if="!isHiddenFields('product')">
          <label>{{$t('labels.common.product')}}</label>
          <div class="d-flex">
            <multiselect v-model="packageData.product" :max-height="200" placeholder=""
                         :tabindex="1"
                         @search-change="asyncProductsSearch" label="name" track-by="id"
                         :loading="isLoadingProducts" @select="fetchProductData"
                         select-label="" deselect-label="" selected-label=""
                         :options="products" :disabled="!operationId"></multiselect>
            <div class="icons-group" @click="createProduct(packageData.product)"
                 title="Edit/create product">
              <icon name="pencil-alt"></icon>
            </div>
            <div class="icons-group" id="add-to-favorite" @click="openPackageTemplateNameDialog"
                 title="Add to favorite" :disabled="!packageData.product">
              <icon name="star"></icon>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="package-params">
          <div v-if="!isHiddenFields('package_nr')">
            <label>{{$t('labels.common.package_nr')}}</label>
            <input class="form-control" v-model="packageData.package_nr"
                   :disabled="isNotEditablePackageField('package_nr')" :tabindex="2">
          </div>
          <div v-if="!isHiddenFields('group')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.group')}}</label>
            <div>
              <multiselect v-model="packageData.group" :max-height="200" label="name" track-by="name"
                           placeholder="" :options="groups"
                           :disabled="isNotEditablePackageField('group')"
                           :class="{ required: !packageData.group}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="3">
              </multiselect>
            </div>
          </div>
          <div v-if="!isHiddenFields('profile')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.profile')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.profile" :max-height="200" label="name" track-by="id"
                           placeholder="" :options="profiles"
                           :disabled="isNotEditablePackageField('profile')"
                           :class="{ required: !packageData.profile}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="4"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('profile')"
                   title="Apply profile to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('profile')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('tree')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.wood')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.tree" :max-height="200" label="name" track-by="id"
                           placeholder="" :options="wood"
                           :disabled="isNotEditablePackageField('tree')"
                           :class="{ required: !packageData.tree}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="5"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('tree')"
                   title="Apply tree to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('tree')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('humidity')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.humidity')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.humidity" :max-height="200" placeholder=""
                           :options="humidity_list" :disabled="isNotEditablePackageField('humidity')"
                           select-label="" deselect-label="" selected-label=""
                           :class="{ required: !packageData.humidity}"
                           :tabindex="6"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('humidity', null)"
                   title="Apply humidity to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('humidity')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('quality')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.quality')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.quality" :max-height="200" label="name" track-by="id"
                           placeholder="" :options="qualities_list"
                           :disabled="isNotEditablePackageField('quality')"
                           :class="{ required: !packageData.quality}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="7"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('quality')"
                   title="Apply quality to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('quality')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('serial_nr')">
            <label>{{$t('labels.packages.serial_nr')}}</label>
            <input type="number" class="form-control" v-model="packageData.serial_nr" min="0"
                   :disabled="isNotEditablePackageField('serial_nr')" tabindex="8">
          </div>
        </b-col>
        <b-col class="package-params">
          <div v-if="!isHiddenFields('impr')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.impr')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.impr" :max-height="200" label="name" track-by="id"
                           placeholder="" :options="imprs"
                           :disabled="isNotEditablePackageField('impr')" :class="{ required: !packageData.impr}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="9"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('impr')"
                   title="Apply impr to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('impr')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('wood_certificate')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.certificate')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.wood_certificate" :max-height="200" label="name"
                           track-by="name" placeholder="" :options="wood_certificates"
                           :disabled="isNotEditablePackageField('wood_certificate')"
                           select-label="" deselect-label="" selected-label=""
                           :class="{ required: !packageData.wood_certificate}"
                           :tabindex="10" :allow-empty="false">
              </multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('wood_certificate', 'id')"
                   title="Apply certificate to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('wood_certificate')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('package_type')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.package_type')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.package_type" :max-height="200" label="name"
                           track-by="name" placeholder="" :options="packageTypes"
                           :class="{ required: !packageData.package_type}"
                           select-label="" deselect-label="" selected-label=""
                           :disabled="isNotEditablePackageField('package_type')"
                           :tabindex="11">
              </multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('package_type')"
                   title="Apply packaging to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('package_type')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('stock_address')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.stock')}}</label>
            <div class="d-flex">
              <multiselect v-model="packageData.stock_address" :max-height="200" label="name"
                           track-by="id" placeholder="" :options="stock_addresses"
                           :disabled="isNotEditablePackageField('stock_address')"
                           :class="{ required: !packageData.stock_address}"
                           select-label="" deselect-label="" selected-label=""
                           :tabindex="12"
              ></multiselect>
              <div class="reply-icon-wrapper" @click="applyToAllPackages('stock_address')"
                   title="Apply stock to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('stock_address')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div>
            <label>{{$t('labels.common.comment')}}</label>
            <div class="d-flex">
              <input class="form-control" v-model="packageData.comment" tabindex="14">
              <div class="reply-icon-wrapper" @click="applyToAllPackages('comment', null)"
                   title="Apply comment to all packages created after this."
                   v-show="operationId && !isNotEditablePackageField('comment')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="packageData.type === 'single'">
        <b-col class="package-params single-params">
          <div v-if="!isHiddenFields('thickness')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.thickness')}}</label>
            <div class="d-flex">
              <input type="number" class="form-control size-param" v-model="packageData.thickness" min="0"
                     @input="calculatePackageM3"
                     :disabled="isNotEditablePackageField('thickness')" :class="{ required: !packageData.thickness}"
                     tabindex="15">
              <div class="reply-icon-wrapper" @click="applyToAllPackages('thickness', null)"
                   title="Apply thickness to all packages"
                   v-show="operationId && !isNotEditablePackageField('thickness')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('width')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.width')}}</label>
            <div class="d-flex">
              <input type="number" class="form-control size-param" v-model="packageData.width" min="0"
                     @input="calculatePackageM3"
                     :disabled="isNotEditablePackageField('width')"
                     :class="{ required: !packageData.width}"
                     tabindex="16">
              <div class="reply-icon-wrapper" @click="applyToAllPackages('width', null)"
                   title="Apply width to all packages"
                   v-show="operationId && !isNotEditablePackageField('width')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('length')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.length')}}</label>
            <div class="d-flex">
              <input type="number" class="form-control size-param" v-model="packageData.length" min="0"
                     @input="calculatePackageM3"
                     :disabled="isNotEditablePackageField('length')"
                     :class="{ required: !packageData.length}" tabindex="17">
              <div class="reply-icon-wrapper" @click="applyToAllPackages('length', null)"
                   title="Apply length to all packages"
                   v-show="operationId && !isNotEditablePackageField('length')">
                <icon name="reply" class="reply-icon"></icon>
              </div>
            </div>
          </div>
          <div v-if="!isHiddenFields('pieces')">
            <label class="important-field"
                   title="This field is required to completing operation">{{$t('labels.common.quantity')}}</label>
            <input type="number" class="form-control" v-model="packageData.pieces"
                   min="0" @input="calculatePackageM3" :disabled="isNotEditablePackageField('pieces')"
                   :class="{ required: !packageData.pieces}" tabindex="18">
          </div>
          <div>
            <label>m3</label>
            <input type="number" class="form-control" v-model="packageData.m3"
                   :disabled="isNotEditablePackageField('m3')">
          </div>
        </b-col>
      </b-row>
      <b-card no-body class="margin-top-10"
              v-if="packageData.type !== 'single' && !packageData.isNew">
        <b-tabs card v-model="currentTabIndex" @changed="tabChanged">
          <b-tab v-for="(subPackage, index) in packageData.subpackages" :key="`dyntab-${index}`"
                 :title="`${subPackage.length || '-'}/${subPackage.quality ? subPackage.quality.name: '-'}`">
            <b-row style="margin-top: 0">
              <b-col class="d-flex justify-content-end">
                <div>
                  <!--<b-btn variant="outline-success" size="sm" title="Save current subpackage"
                         @click="saveSubPackageRequest(subPackage)" :disabled="!operationId">
                      {{$t('buttons.common.save')}}
                  </b-btn>-->
                  <b-btn variant="outline-danger" size="sm" title="Delete current subpackage"
                         @click="deleteSubPackage(subPackage)" :disabled="!operationId"
                         tabindex="100">
                    {{$t('buttons.common.delete')}}
                  </b-btn>
                </div>
              </b-col>
            </b-row>
            <div v-if="packageData.type === 'float'">
              <b-row>
                <b-col>
                  <label>{{$t('labels.packages.serial_nr')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.serial_nr" min="0"
                         :disabled="isDisabledSubpackageField(subPackage, 'serial_nr')" tabindex="19">
                </b-col>
                <b-col>
                  <label class="important-field"
                         title="This field is required to completing operation">{{$t('labels.common.thickness')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.thickness" min="0"
                         @input="calculateSubPackageM3(subPackage)"
                         :disabled="isDisabledSubpackageField(subPackage, 'thickness')"
                         :class="{ required: !subPackage.thickness}" tabindex="22">
                </b-col>
                <b-col>
                  <label>{{$t('labels.common.quantity')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.width_list.length"
                         disabled>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <label class="important-field"
                         title="This field is required to completing operation">{{$t('labels.common.quality')}}</label>
                  <multiselect v-model="subPackage.quality" :max-height="200" label="name"
                               track-by="id" placeholder="" :options="qualities_list"
                               :disabled="isDisabledSubpackageField(subPackage, 'quality')"
                               :class="{ required: !subPackage.quality}"
                               select-label="" deselect-label="" selected-label=""
                               :tabindex="20"
                  ></multiselect>
                </b-col>
                <b-col>
                  <label class="important-field"
                         title="This field is required to completing operation">{{$t('labels.common.length')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.length" min="0"
                         @input="calculateSubPackageM3(subPackage)"
                         :disabled="isDisabledSubpackageField(subPackage, 'length')"
                         :class="{ required: !subPackage.length}" tabindex="23">
                </b-col>
                <b-col>
                  <label>{{$t('labels.packages.total_width')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.total_width" disabled>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <label>{{$t('labels.common.comment')}}</label>
                  <input class="form-control" v-model="subPackage.comment" tabindex="21">
                </b-col>
                <b-col>
                  <label>{{$t('labels.common.width')}}</label>
                  <div class="d-flex">
                    <input class="form-control subpackage-width"
                           :disabled="isDisabledSubpackageField(subPackage, 'width')"
                           @keyup.enter="addWidth(subPackage, index)"
                           :ref="`subpackage-width-${index}`" tabindex="24">
                    <div class="icons-group vertical-center-container" title="Add width"
                         @click="addWidth(subPackage, index)">
                      <icon name="plus-circle"></icon>
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <label>{{$t('labels.packages.average_width')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.average_width"
                         disabled>
                </b-col>
              </b-row>
              <b-row>
                <b-col offset="4" cols="4">
                  <label class="important-field"
                         title="Width list can't be empty for completing of operation">
                    {{$t('labels.packages.width_list')}}</label>
                  <div class="width-list" v-if="subPackage.width_list.length">
                    <input class="form-control" v-for="(width, widthIndex) in subPackage.width_list"
                           :key="`${index}/${widthIndex}`" :value="width"
                           @input="changeWidth($event, subPackage, widthIndex, index)"
                           :ref="`width-item-${index}`"
                           :disabled="isDisabledSubpackageField(subPackage, 'width_list')">
                  </div>
                  <div v-else class="warning-text">
                    {{$t('modal_dialogs.width_list_empty')}}
                  </div>
                </b-col>
                <b-col cols="4">
                  <label>m3</label>
                  <input class="form-control" type="number" v-model="subPackage.m3" disabled>
                </b-col>
              </b-row>
            </div>
            <div v-if="packageData.type === 'mix'">
              <b-row>
                <b-col cols="4">
                  <label>{{$t('labels.packages.serial_nr')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.serial_nr" min="0"
                         :disabled="isDisabledSubpackageField(subPackage, 'serial_nr')" tabindex="19">
                </b-col>
                <b-col cols="4">
                  <label class="important-field"
                         title="This field is required to completing operation">{{$t('labels.common.quantity')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.pieces" min="0"
                         @input="calculateSubPackageM3(subPackage)"
                         :disabled="isDisabledSubpackageField(subPackage, 'pieces')"
                         :class="{ required: !subPackage.pieces}" tabindex="24">
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <label class="important-field"
                         title="This field is required to completing operation">{{$t('labels.common.quality')}}</label>
                  <multiselect v-model="subPackage.quality" :max-height="200" label="name"
                               track-by="id" placeholder="" :options="qualities_list"
                               :disabled="isDisabledSubpackageField(subPackage, 'quality')"
                               :class="{ required: !subPackage.quality}"
                               select-label="" deselect-label="" selected-label="" :tabindex="20"
                  ></multiselect>
                </b-col>
                <b-col cols="4">
                  <label>m3</label>
                  <input class="form-control" type="number" v-model="subPackage.m3" disabled>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <label class="important-field"
                         title="This field is required to completing operation">{{$t('labels.common.thickness')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.thickness" min="0"
                         @input="calculateSubPackageM3(subPackage)"
                         :disabled="isDisabledSubpackageField(subPackage, 'thickness')"
                         :class="{ required: !subPackage.thickness}" tabindex="21">
                </b-col>
                <b-col cols="4">
                  <label>{{$t('labels.common.comment')}}</label>
                  <input class="form-control" v-model="subPackage.comment" tabindex="25">
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <label class="important-field"
                         title="This field is required to completing operation">{{$t('labels.common.width')}}</label>
                  <input class="form-control" v-model="subPackage.width"
                         @input="calculateSubPackageM3(subPackage)"
                         :disabled="isDisabledSubpackageField(subPackage, 'width')"
                         :class="{ required: !subPackage.width}" tabindex="22">
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="4">
                  <label class="important-field"
                         title="This field is required to completing operation">{{$t('labels.common.length')}}</label>
                  <input class="form-control" type="number" v-model="subPackage.length" min="0"
                         @input="calculateSubPackageM3(subPackage)"
                         :disabled="isDisabledSubpackageField(subPackage, 'length')"
                         :class="{ required: !subPackage.length}" tabindex="23">
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <template slot="tabs-end" v-if="operationId" tabindex="100">
            <li @click.prevent="addNewSubPackage" title="Add new subpackage" class="nav-item">
              <a class="nav-link" target="_self" href="#" tabindex="100">+</a>
            </li>
          </template>
        </b-tabs>
      </b-card>
    </div>
    <b-popover target="package-creating" placement="bottom" ref="package-creating-popover">
      <div>
        <b-btn size="sm" class="full-width" title="Create single package" @click="openPackageForm('single')">
          {{$t('common_content.single')}}
        </b-btn>
      </div>
      <div class="d-flex mt-1" v-if="!packageData.isNew">
        <input type="number" ref="copies-count" value="1" class="form-control margin-right-5" min="0">
        <b-btn size="sm" class="full-width" @click="createCopies" title="Create copies of package">
          {{$t('buttons.packages.copies')}}
        </b-btn>
      </div>
    </b-popover>
    <div slot="modal-footer" class="w-100 text-center">
      <div class="button-group margin-0" v-if="operationId">
        <b-btn size="sm" variant="success" @click="save(false)"
               :title="packageData.isNew ? 'Create package' : 'Save changes for package'">
          {{$t('buttons.common.save')}}
        </b-btn>
        <!-- <b-btn size="sm" variant="outline-success" @click="save(true)">
            {{$t('buttons.common.save_and_exit')}}
        </b-btn> -->
        <b-btn size="sm" variant="warning" id="package-creating">
          {{$t('buttons.common.create')}}
        </b-btn>
        <b-btn size="sm" variant="outline-primary" title="Create package based on changes"
               v-if="!packageData.isNew && packageData.type === 'single'" @click="createBasedOnChanges">
          {{$t('buttons.common.create_based_on_changes')}}
        </b-btn>
        <b-btn size="sm" variant="danger" title="Delete package" v-if="!packageData.isNew"
               @click="deletePackage">
          {{$t('buttons.common.delete')}}
        </b-btn>
        <!-- <b-btn size="sm" @click="save(true)" variant="outline-secondary">
          <icon name="times"></icon>
          {{$t('buttons.common.save_and_exit')}}
        </b-btn> -->
      </div>
    </div>
  </b-modal>
</template>

<script>
  import { mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import { handlerResponse, setNotifyData, isObject } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { Decimal } from 'decimal.js';
  import PurchaseOrderItemSearchField from '@/components/common/operation/PurchaseOrderItemSearchField'

  export default {
    props: ['fetchCallback', 'operationId'],
    components: {
      Multiselect,
      PurchaseOrderItemSearchField
    },
    data() {
      return {
        isLoadingProducts: false,
        operation: {},
        packageData: {},
        initialPackageData: {
          package_nr: '',
          product: null,
          package_type: null,
          wood_certificate: null,
          group: null,
          humidity: null,
          profile: null,
          partner: null,
          serial_nr: '',
          tree: null,
          stock_address: null,
          impr: null,
          comment: '',
          thickness: 0,
          width: 0,
          length: 0,
          quality: null,
          pieces: 0,
          m3: '',
          pre_purchase_order: null,
          contract_nr: null,
          subpackages: [],
          editable: true
        },
        products: [],
        purchase_orders: [],
        currentTabIndex: 0
      }
    },
    methods: {
      async fetchDataBySelected (selectedItem, type = 'product') {
        const { id } = selectedItem
        const url = type === 'product' ? `woodware/products/${id}/` : `purchase/order_items_for_package/${id}/`
        if (id) {
          const { data: response } = await this.$http.get(url)
          delete response.id
          for (let [key, value] of Object.entries(response)) {
            if (!this.isHiddenFields(key) && !this.isNotEditablePackageField(key)) {
              this.packageData[key] = value
            }
          }
          await this.calculatePackageM3()
        }
      },
      async setFieldsByPurchaseOrderItem (data) {
        await this.fetchDataBySelected(data, 'purchase_order_item')
      },
      async fetchContracts (order) {
        const order_id = order?.id
        if (order_id) {
          await this.$store.dispatch('contracts/loadRelatedToOrderContracts', { order_id });
          const { contract_nr } = this.packageData
          const isThereNoCurrentContract = !this.relatedContracts.find(el => el.id === contract_nr?.id)
          if (isThereNoCurrentContract) {
            this.$set(this.packageData, 'contract_nr', null)
          }
        } else {
          await this.$store.dispatch('contracts/clearRelatedContracts');
        }
      },
      asyncProductsSearch(query) {
        if (query) {
          const params = {
            limit: 50,
            offset: 0,
            text: query
          };
          this.isLoadingProducts = true;
          let url = 'woodware/list/search_for_product_short_view/'
          this.$http.get(url, {params}).then(handlerResponse)
            .then(response => {
              this.isLoadingProducts = false;
              this.products = response.results;
            });
        }
      },
      fetchProductData(selectedProduct) {
        const id = selectedProduct.id;
        if (id) {
          this.$http.get(`woodware/products/${id}/`).then(handlerResponse).then((response) => {
            delete response.id;
            for (let [key, value] of Object.entries(response)) {
              if (!this.isHiddenFields(key) && !this.isNotEditablePackageField(key)) {
                this.packageData[key] = value;
              }
            }
            this.calculatePackageM3();
          });
        }
      },
      async fetchPurchaseOrders(shipper = this.packageData.partner?.id) {
        try {
          if (shipper) {
            this.purchase_orders = await this.$http.get(`woodware/list/purchase_orders/`, {
              params: { ...this.operation, shipper }
            }).then(handlerResponse);
            const { pre_purchase_order } = this.packageData
            const isThereNoCurrentPO = !this.purchase_orders.find(el => el.id === pre_purchase_order?.id)
            if (isThereNoCurrentPO) {
              this.$set(this.packageData, 'pre_purchase_order', null)
            }
          } else {
            this.purchase_orders = []
          }
        } catch (e) {
          console.log(e);
        }
      },
      prepareSavedPackageData() {
        return {
          movement: this.operationId,
          pieces: this.packageData.pieces,
          comment: this.packageData.comment,
          humidity: this.packageData.humidity,
          group: this.packageData.group && this.packageData.group.id,
          impr: this.packageData.impr && this.packageData.impr.id,
          length: this.packageData.length,
          package_nr: this.packageData.package_nr,
          package_type: this.packageData.package_type && this.packageData.package_type.id,
          partner: this.packageData.partner && this.packageData.partner.id,
          profile: this.packageData.profile && this.packageData.profile.id,
          quality: this.packageData.quality && this.packageData.quality.id,
          serial_nr: this.packageData.serial_nr || null,
          purchase_order_item: this.packageData.purchase_order_item?.id,
          pre_purchase_order: this.packageData.pre_purchase_order && this.packageData.pre_purchase_order.id,
          stock_address: this.packageData.stock_address && this.packageData.stock_address.id,
          thickness: this.packageData.thickness,
          tree: this.packageData.tree && this.packageData.tree.id,
          width: this.packageData.width,
          wood_certificate: this.packageData.wood_certificate && this.packageData.wood_certificate.id,
          type: this.packageData.type,
          contract: this.packageData.contract_nr?.id
        }
      },
      calculatePackageM3() {
        const {pieces, thickness, width, length} = this.packageData;
        const k = 1;
        this.packageData.m3 = (k * pieces * thickness * width * length / 1000000000).toFixed(3);
      },
      createProduct(product) {
        const productId = product ? product.id : 'new';
        window.open(`/product/${productId}`, '_blank');
      },
      openPackageTemplateNameDialog() {
        const namePlaceholder = this.$i18n.t('placeholders.enter_package_template_name');
        const countPlaceholder = this.$i18n.t('placeholders.enter_count_of_pcs_in_package');
        this.$swal.fire({
          title: this.$i18n.t(`dialogs.create_package_template`),
          html:
            `<input id="template-name" class="form-control">
             <input id="pieces" style="margin-top: 10px" class="form-control" type="number">`,
          focusConfirm: false,
          onBeforeOpen: () => {
            document.getElementById('pieces').value = this.packageData.pieces;
            document.getElementById('template-name').placeholder = namePlaceholder;
            document.getElementById('pieces').placeholder = countPlaceholder;
          },
          preConfirm() {
            return {
              name: document.getElementById('template-name').value,
              pieces: document.getElementById('pieces').value
            }
          },
          showCancelButton: true,
          cancelButtonText: this.$i18n.t(`buttons.common.cancel`)
        }).then(result => {
          if (result.value) {
            this.addPackageTemplate(result.value)
          }
        });
      },
      async savePackage() {
        const payload = this.prepareSavedPackageData();
        const loader = this.$loading.show();
        if (this.packageData.isNew) {
          try {
            const response = await this.$http.post(`woodware/movement_data/`, payload).then(handlerResponse);
            this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
              this.$i18n.t(`notifications.packages.new_package_created`), 'success'));
            const packageNrBuffer = this.packageData.package_nr
            this.packageData = { ...this.packageData, ...response, package_nr: packageNrBuffer }
            delete this.packageData.isNew;
            this.fetchCallback();
            loader.hide();
          } catch (error) {
            notificationsRenderer(error.data, 'error');
            loader.hide();
            throw error.data;
          }
        } else {
          try {
            await this.$http.put(`woodware/movement_data/${this.packageData.id}/`, payload).then(handlerResponse);
            if (this.packageData.subpackages.length) {
              const currentSubPackage = this.packageData.subpackages[this.currentTabIndex];
              await this.saveSubPackageRequest(currentSubPackage);
              this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
                this.$i18n.t(`notifications.packages.package_updated`), 'success'));
              this.fetchCallback();
              loader.hide();
            } else {
              this.fetchCallback();
              loader.hide();
            }
          } catch (error) {
            notificationsRenderer(error.data, 'error');
            loader.hide();
            throw error.data;
          }
        }
      },
      async save(exitFlag) {
        try {
          await this.savePackage();
          if (exitFlag) {
            this.$refs['PackageModal'].hide();
          }
        } catch (e) {
          console.log(e);
        }
      },
      createBasedOnChanges() {
        const payload = this.prepareSavedPackageData();
        this.$http.post(`woodware/create_movement_data_based_changes/`, payload).then(handlerResponse).then(() => {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
            this.$i18n.t(`notifications.packages.new_package_created`), 'success'));
          this.fetchCallback();
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      async openPackageForm(type) {
        await this.savePackage();
        delete this.packageData['non_editable_fields'];
        this.packageData.type = type;
        if (this.packageData.serial_nr) {
          ++this.packageData.serial_nr
        }
        this.packageData.comment = '';
        //this.packageData.thickness = 0;
        this.packageData.pieces = 0;
        this.packageData.isNew = true;
        this.packageData.package_nr = '';
        this.$refs['package-creating-popover'].$emit('close');
        this.savePackage();
      },
      tabChanged(currentTabs, previousTabs) {
        if (this.packageData.type !== 'single') {
          if (previousTabs.length) {
            this.currentTabIndex = this.packageData.subpackages.length - 1;
          }
        } else {
          this.currentTabIndex = 0;
        }
      },
      addNewSubPackage() {
        const currentSubPackage = this.packageData.subpackages[this.currentTabIndex];
        const payload = {
          movement: this.operationId,
          parent: this.packageData.id,
          type: 'subpackage'
        };
        if (currentSubPackage) {
          const subPackageQuality = this.packageData.subpackages[this.currentTabIndex].quality;
          const thickness = this.packageData.subpackages[this.currentTabIndex].thickness;
          const serial_nr = this.packageData.subpackages[this.currentTabIndex].serial_nr;
          payload.quality = subPackageQuality && subPackageQuality.id;
          payload.thickness = thickness;
          if (serial_nr) {
            payload.serial_nr = Number(serial_nr) + 1;
          }
        }
        this.$http.post(`woodware/movement_data/`, payload).then(handlerResponse).then(response => {
          this.packageData.subpackages.push(response);
          this.fetchCallback();
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      prepareSubPackageData(subPackage) {
        return {
          thickness: subPackage.thickness,
          length: subPackage.length,
          quality: subPackage.quality && subPackage.quality.id,
          pieces: subPackage.pieces,
          comment: subPackage.comment,
          serial_nr: subPackage.serial_nr || null
        }
      },
      saveSubPackageRequest(subPackage) {
        return new Promise((resolve, reject) => {
          const payload = this.prepareSubPackageData(subPackage);
          if (this.packageData.type === 'float') {
            payload.width_list = subPackage.width_list;
          } else if (this.packageData.type === 'mix') {
            payload.width = subPackage.width;
          }
          this.$http.put(`woodware/movement_data/${subPackage.id}/`, payload).then(handlerResponse).then((response) => {
            subPackage = {...subPackage, ...response};
            resolve();
          }).catch(error => {
              reject(error);
            }
          );
        })
      },
      async delayedSavingSubPackage(requestData) {
        await this.saveSubPackageRequest(requestData);
      },
      async createCopies() {
        const copies = Number(this.$refs['copies-count'].value);
        const payload = {
          packet: this.packageData.id,
          copies
        };
        await this.savePackage();
        this.$http.post(`woodware/movement_data/create_duplicate/`, payload).then(handlerResponse).then(() => {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
            this.$i18n.t(`notifications.packages.count_packages_created`, {count: copies}), 'success'));
          this.fetchCallback();
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      addPackageTemplate(data) {
        const payload = {
          ...data,
          product: this.packageData.product.id
        };
        if (payload.name) {
          this.$http.post(`woodware/product_templates/`, payload).then(handlerResponse).then(() => {
            this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
              this.$i18n.t(`notifications.packages.packages_added_to_favorite`), 'success'));
            this.$store.dispatch('woodware/loadProductTemplates');
          }).catch(error => notificationsRenderer(error.data, 'error'));
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.enter_template_name`), ``, 'warn'));
        }
      },
      deletePackage() {
        this.$http.delete(`woodware/movement_data/${this.packageData.id}/`).then(handlerResponse).then(() => {
          this.$refs['PackageModal'].hide();
          this.fetchCallback();
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
            this.$i18n.t(`notifications.packages.package_deleted`), 'success'));
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      applyToAllPackages(paramName, key = 'id') {
        const applyParam = this.$i18n.t(`labels.common.${paramName}`).toLowerCase();
        const packageNr = this.packageData.id;
        if (this.packageData[paramName]) {
          const value = key ? this.packageData[paramName][key] : this.packageData[paramName];
          const title = this.$i18n.t(`dialogs.apply_to_all_confirm`, {applyParam})
          this.$swal.fire(this.prepareConfirmDialog(title))
            .then(result => {
              if (result.value) {
                const loader = this.$loading.show();
                let payload
                payload = {
                  [paramName]: value
                };
                if (paramName === 'contract_nr') {
                  payload = {
                    'pre_purchase_order': this.packageData.pre_purchase_order.id,
                    'contract': value
                  };
                }
                this.$http.put(`woodware/operations/${this.operationId}/update_created_after_package/${packageNr}/`, payload)
                  .then(handlerResponse).then(() => {
                  this.fetchCallback();
                  this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
                    this.$i18n.t(`notifications.packages.applied_param_in_operation`, {applyParam}), 'success'));
                  loader.hide();
                }).catch(error => {
                  notificationsRenderer(error.data, 'error');
                }).finally(() => {
                  loader.hide();
                });
              }
            })
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.select_value_for_applying`, {applyParam}),
            '', 'warn'));
        }
      },
      deleteSubPackage(subPackage) {
        this.$http.delete(`woodware/movement_data/${subPackage.id}/`).then(handlerResponse).then(() => {
          for (let i = 0; i < this.packageData.subpackages.length; i++) {
            if (this.packageData.subpackages[i].id === subPackage.id) {
              this.packageData.subpackages.splice(i, 1)
            }
          }
          this.fetchCallback();
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.success`),
            this.$i18n.t(`notifications.packages.subpackage_deleted`), 'success'));
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      addWidth(currentSubPackage, index) {
        const widthElem = this.$refs[`subpackage-width-${index}`][0];
        let widthValue = widthElem.value;
        if (widthValue) {
          const separator = ' ';
          if (widthValue.includes(separator)) {
            const widthValues = widthValue.split(separator).filter(item => item !== ''); // if has more than 1 space
            currentSubPackage.width_list = currentSubPackage.width_list.concat(widthValues);
          } else {
            widthValue = Number(widthValue);
            if (!isNaN(widthValue)) {
              currentSubPackage.width_list.push(widthValue);
            } else {
              this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.enter_valid_width_width_list`), '', 'error'));
              return;
            }
          }
          this.sumTotalWidthDataForSubPackage(currentSubPackage);
          this.calculateSubPackageM3(currentSubPackage);
          widthElem.value = '';
        }
      },
      changeWidth(event, currentSubPackage, widthIndex, subPackageIndex) {
        const currentWidth = Number(event.target.value);
        if (event.target.value === '') {
          currentSubPackage.width_list.splice(widthIndex, 1);
          this.sumTotalWidthDataForSubPackage(currentSubPackage);
          this.calculateSubPackageM3(currentSubPackage);
          this.$nextTick(() => {
            const widthsList = this.$refs[`width-item-${subPackageIndex}`];
            if (widthsList.length) {
              widthsList[widthIndex - 1].focus();
            } else {
              this.$refs[`subpackage-width-${subPackageIndex}`][0].focus();
            }
          })
          return;
        }
        if (!isNaN(currentWidth)) {
          this.$set(currentSubPackage.width_list, widthIndex, currentWidth);
          this.sumTotalWidthDataForSubPackage(currentSubPackage);
          this.calculateSubPackageM3(currentSubPackage);
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.enter_valid_width`), '', 'error'));
        }
      },
      calculateSubPackageM3(subPackage) {
        const {pieces, thickness, width, length, total_width} = subPackage;
        if (this.packageData.type === 'float') {
          subPackage.m3 = (total_width * thickness * length / 1000000000).toFixed(3);
        } else if (this.packageData.type === 'mix') {
          subPackage.m3 = (pieces * thickness * width * length / 1000000000).toFixed(3);
        }
      },
      sumTotalWidthDataForSubPackage(subPackage) {
        try {
          subPackage.total_width = subPackage.width_list.reduce((sum, current) => {
            return Decimal.add(sum, current);
          }, 0);
          if (subPackage.width_list.length) {
            subPackage.average_width = (subPackage.total_width / subPackage.width_list.length).toFixed(2);
          } else {
            subPackage.average_width = 0;
          }
        } catch (e) {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.packages.enter_valid_width`), '', 'error'));
        }
      },
      checkValidFormData(checkedFields, checkedData) {
        return checkedFields.filter((item) => {
          if (!isObject(checkedData[item.field])) { // if multiselect isn't empty it has object format data
            return Array.isArray(checkedData[item.field]) ? checkedData[item.field].length
              : Number(checkedData[item.field])
          } else {
            return checkedData[item.field];
          }
        }).length === checkedFields.length;
      },
      getNotFilledFields(checkedFields, checkedData) {
        return checkedFields.filter((item) => {
          if (!isObject(checkedData[item.field])) { // if multiselect isn't empty it has object format data
            return Array.isArray(checkedData[item.field]) ? !checkedData[item.field].length
              : !Number(checkedData[item.field]);
          }
        }).map(item => {
          if (item.label) {
            return item.label
          }
          return _.upperFirst(item.field);
        });
      },
      calculateDataForSubPackages() {
        this.packageData.subpackages.forEach((subPackage) => {
          this.sumTotalWidthDataForSubPackage(subPackage);
        });
      },
      isNotEditablePackageField(field) {
        if (this.packageData.non_editable_fields && this.packageData.non_editable_fields.length) {
          return this.packageData.non_editable_fields.includes(field);
        }
      },
      isDisabledSubpackageField({non_editable_fields}, field) {
        if (non_editable_fields && non_editable_fields.length) {
          return non_editable_fields.includes(field);
        }
      },
      isHiddenFields(field) {
        if (this.packageData.hidden_fields && this.packageData.hidden_fields.length) {
          return this.packageData.hidden_fields.includes(field);
        }
      },
      cleanAddingWidth() {
        for (let key in this.$refs) {
          if (this.$refs.hasOwnProperty(key) && key.includes('subpackage-width')) {
            if (this.$refs[key].length) {
              this.$refs[key][0].value = '';
            }
          }
        }
      },
      hiddenModal() {
        this.cleanAddingWidth();
      },
      prepareConfirmDialog(title, icon = 'question') {
        return {
          title,
          icon,
          showCancelButton: true,
          confirmButtonColor: '#1bc14d',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$i18n.t(`common_content.yes`),
          cancelButtonText: this.$i18n.t(`common_content.no`)
        }
      },
      closeModal() {
        this.$refs['PackageModal'].hide();
      }
    },
    async mounted() {
      this.$root.$on('openPackageModal', async (data) => {
        this.operation = {
          type: data.operationType,
          contract: data.operationContract
        }
        this.packageData = {...this.initialPackageData};
        await this.$store.cache.dispatch('generic/loadPackageTypes');
        await this.$store.cache.dispatch('woodware/getWoodCertificates');
        await this.$store.cache.dispatch('woodware/getProfiles');
        await this.$store.cache.dispatch('woodware/getWood');
        await this.$store.cache.dispatch('woodware/getStockAddresses');
        await this.$store.cache.dispatch('contracts/loadContractsList');
        await this.$store.cache.dispatch('woodware/getImprs');
        await this.$store.cache.dispatch('woodware/getQualitiesList');
        await this.$store.cache.dispatch('woodware/loadHumidityList');
        await this.$store.cache.dispatch('woodware/getGroupsWithHierarchy');
        this.packageData = {...this.packageData, ...data, contract_nr: data.contract };
        // await this.fetchPurchaseOrders();
        if (this.packageData.type !== 'single') {
          this.calculateDataForSubPackages();
        }
        if (this.$refs['PackageModal']) {
          this.$refs['PackageModal'].show();
          this.$nextTick(() => {
            const tabsPanel = document.querySelectorAll('.modal-dialog .nav-tabs')[0];
            if (tabsPanel) {
              tabsPanel.setAttribute('tabIndex', '100');
            }
          })
        }
      });
      this.$root.$on('closePackageModal', () => {
        this.$nextTick(() => {
          if (this.$refs['PackageModal']) {
            this.$refs['PackageModal'].hide();
          }
        });
      });
    },
    watch: {
      async 'packageData.partner' (value) {
        await this.fetchPurchaseOrders(value?.id)
      },
      currentTabIndex(current, prev) {
        const previousSubPackage = this.packageData.subpackages[prev];
        if (previousSubPackage) {
          this.saveSubPackageRequest(previousSubPackage);
        }
      },
      'packageData.pre_purchase_order' (value) {
        this.fetchContracts(value)
      }
    },
    computed: {
      ...mapState('generic', ['packageTypes']),
      ...mapState('contracts', ['relatedContracts']),
      ...mapState('woodware', ['wood_certificates', 'profiles', 'partners', 'wood', 'stock_addresses', 'imprs',
        'qualities_list', 'humidity_list', 'groups']),
      contractsRequired () {
        return !this.packageData.contract_nr && this.relatedContracts.length
      },
      title() {
        if (this.packageData.type) {
          return this.$i18n.t(`common_content.${this.packageData.type}`);
        }
      }
    },
    beforeDestroy() {
      this.$root.$off('openPackageModal');
      this.$root.$off('closePackageModal');
    }
  }
</script>

<style scoped lang="scss">
  label {
    display: flex;
    align-items: center;
  }

  .row {
    margin-top: 6px;
  }

  .package-params {
    > div {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;

      > div, > input {
        width: 60%;
      }
    }

    &.single-params > div {
      > div, input {
        width: 75%;
      }

      .size-param {
        width: 95%;
      }
    }
  }

  .width-list {
    max-height: 180px;
    overflow-y: auto;

    input {
      min-height: 20px;
      height: 20px;
      margin-top: 1px;
      padding: 1px 0 1px 10px;
      border-radius: 0;

      &:active, &:focus {
        border: 1px solid #80bdff;
        box-shadow: none;
      }
    }
  }

  .warning-text {
    color: #fb8469;
    font-size: 13px;
  }

</style>



// WEBPACK FOOTER //
// src/components/modals/PackageModal.vue